// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3kqnD","wrapper":"styles_wrapper__2Pu0L","title":"styles_title__1wz-K","right_side":"styles_right_side__9fdo9"};